/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M512 97.282c-18.818 8.35-39.06 14.003-60.331 16.518 21.694-13.002 38.362-33.581 46.21-58.102a210.663 210.663 0 01-66.696 25.491C412.032 60.761 384.7 48 354.487 48c-58 0-105.036 47.04-105.036 105.066 0 8.23.94 16.26 2.728 23.959-87.301-4.38-164.695-46.237-216.512-109.794-9.06 15.519-14.242 33.567-14.242 52.829 0 36.447 18.545 68.604 46.726 87.457-17.181-.546-33.394-5.287-47.544-13.155v1.318c0 50.92 36.21 93.366 84.24 103.02-8.817 2.41-18.09 3.68-27.667 3.68-6.757 0-13.363-.65-19.756-1.877 13.363 41.748 52.15 72.119 98.12 72.954-35.97 28.187-81.241 44.992-130.453 44.992-8.486 0-16.848-.5-25.091-1.472 46.516 29.81 101.726 47.224 161.06 47.224 193.186 0 298.85-160.121 298.85-298.952 0-4.545-.091-9.077-.3-13.592 20.542-14.823 38.329-33.325 52.39-54.375z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconTwitterAlt = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconTwitterAlt.defaultProps = {
  theme,
};
IconTwitterAlt.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconTwitterAlt.displayName = 'IconTwitterAlt';
export { IconTwitterAlt };
